<template>
  <div class="error-page">
    <img
      :src="$asset('/cdn/logotype-undergraduate-light.svg', { source: 'imageboss' })"
      alt="Logo da Quero Bolsa"
      width="245"
      height="38"
    >

    <div class="z-mt-0800">
      <z-title
        tag="h1"
        size="large"
      >
        {{ errorTitle }}
      </z-title>

      <z-text
        v-if="isNotFoundError"
        size="large"
        tag="p"
      >
        Não encontramos a página que você está tentando acessar.
        <br>
        Mas não desista ainda! Continue procurando sua bolsa de estudos.
        <br>
        A Quero Bolsa oferece vagas com bolsa de estudos de até 75% de desconto nas melhores faculdades do Brasil.
      </z-text>

      <z-button
        href="/enem/manual-do-enem"
        class="error-page__link"
      >
        Ir para página inicial
      </z-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ErrorLayout',
  layout: 'empty',
  props: {
    error: {
      type: Object,
      required: true,
    },
  },
  computed: {
    errorTitle () {
      if (this.isNotFoundError) {
        return 'A página que você está procurando não existe.'
      }

      return 'Ocorreu um problema com a página que você está tentando acessar.'
    },
    isNotFoundError () {
      return this.error.statusCode === 404
    },
  },
}
</script>

<style lang="scss" scoped>
.error-page {
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 100vh;
  text-align: center;

  @media (max-width: $breakpoint-phone) {
    padding: var(--unit-1200) var(--unit-0400);
  }
}

.error-page__link {
  @media (max-width: $breakpoint-phone) {
    width: 100%;
  }
}
</style>
